import { defineSchema, SchemaInstance } from "../type-system/schema";
import { baseMarketingEmailSchema } from "./marketing/marketing";

export const ProductSubscriptionSchema = defineSchema({
  fields: {
    ...baseMarketingEmailSchema.fields,
    subscriptionInfo: {
      dataType: "Subscription Info",
      documentation: "Information about the subscription and upcoming charge.",
    },
  },
});

export const exampleProductSubscriptionSchemaInstance: SchemaInstance<
  typeof ProductSubscriptionSchema
> = {
  redoCustomerId: "65f9d2d37fd7c5a1d2c19876",
  customerEmail: "john@fake.com",
  unsubscribeLink: undefined,
  oneClickUnsubscribeLink: undefined,
  viewInBrowserLink: undefined, // gets populated later
  cartContext: {
    existingCartId: null,
    productIdsForRecommendations: [],
    alreadyInCart: [],
  },
  customerFirstName: "John",
  customerLastName: "Doe",
  customerFullName: "John Doe",
  subscriptionInfo: {
    subscriptionId: "sub_123456",
    products: [
      {
        product: {
          id: "product_123",
          title: "Example Product",
          variantDimensions: [],
          variants: [
            {
              id: "variant_456",
              title: "Default Title",
              formattedPrice: "$29.99",
              price: { amount: 29.99, currencyCode: "USD" },
              image: "https://placehold.co/400x400",
              selectedOptions: [],
            },
          ],
          primaryImageUrl: "https://placehold.co/400x400",
        },
        selectedVariantId: "variant_456",
        quantity: 1,
      },
    ],
    nextChargeDate: "2024-02-15",
    chargeAmount: "$29.99",
    chargeFrequency: "monthly",
  },
};
